import Typography from '@mui/material/Typography'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid'
import { useTranslation } from 'react-i18next'

export default function RulesAndPenalties ({ race }) {
  const { t } = useTranslation('raceGuide')
  const { rules, penalties } = race || {}
  return (
    <>
      <Typography variant='h6'>{t('rules.rulesTitle')}</Typography>
      <List>
        {rules?.map((rule, index) => (
          <ListItem key={index}>
            <ListItemText
              primary={<Typography variant='body1'>{`${index + 1}. ${rule}`}</Typography>}
            />
          </ListItem>
        ))}
      </List>

      <Typography
        variant='h6' sx={{
        my: 1
      }}
      >{t('rules.penaltiesTitle')}</Typography>
      <Grid container spacing={2}>
        {penalties?.map((penalty, index) => (
          <Grid size={{ xs: 6, md: 4, lg: 3 }} key={index}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant='subtitle1' component='div' sx={{ mb: 1 }}>
                  {penalty.title}
                </Typography>
                <Typography variant='body2' color='warning'>
                  {t('rules.penalty', { penalty: penalty.penalty })}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </>
  )
}
